'use strict';

$ (function () {
    // Register
    $ (".submit-register").click (function () {
        if (!$ ("form")[0].checkValidity ()) {
            $ (".oegdproptin").addClass ("error");
            $ (".agb-content").addClass ("error");
    
            if (!$ ('#toggle-mrs-billing').is (':checked') && !$('#toggle-mr-billing').is (':checked')) {
                $ (".salutation-btn").addClass ("error");
            }
        }
    });
    
    $ (".salutation-btn input").click (function () {
        if ($ ('#toggle-mrs-billing').is (':checked') || $('#toggle-mr-billing').is (':checked')) {
            $ (".salutation-btn").removeClass ("error");
        }
    });
    
    // Checkout Summary
    $ (".submit-checkout").click (function () {
        if ($ ('#orderConfirmAgb [type=checkbox]').filter ('[required]:visible')) {
            $ (".agb-content").addClass ("error");
        }
    });
});
